<script>
    import { navigate } from "svelte-routing";
    import { logged_in, project_list, show_header, show_sidebar } from "../app-store";
    import { onDestroy } from "svelte";
    import Breadcrumb from "./Breadcrumb.svelte";
    import SidebarToggler from "./SidebarToggler.svelte";
    import EmailBadge from "./EmailBadge.svelte";

    let project_ref = '';
    let draft_refcode = '';


    function handleLogout() {
        window.app.storage.remove("creds");
        logged_in.set(false);
        navigate("/");
        window.location.href = document.baseURI;
        window.location.reload();
    }

    logged_in.subscribe((value) => {
        console.log("logged_in", value)
        if (value) {
            show_header.set(true);
        } else {
            show_header.set(false);
        }
    });

    const unsub_project_list = project_list.subscribe((projects) => {
        let project = projects.find((p) => p.is_active);
        if (project) {
            project_ref = project.project_ref;
            let draft = project.drafts.find((d) => d.is_active)
            if (draft) {
                draft_refcode = draft.refcode;
            }
        }
    })

    onDestroy(() => {
        show_header.set(false);
        unsub_project_list();
    });
</script>

<header id="header" class="header {$show_header ? 'show' : ''}">
    <SidebarToggler show={true} onToggle={() => {$show_sidebar ? show_sidebar.set(false) : show_sidebar.set(true)}} />
    <Breadcrumb
        items={[
            { id: "breadcrumb-project-list", label: "Projects", alaways_enabled: true, to: "/project-list" },
            { id: "breadcrumb-project", label: "Project", to: `/project/${project_ref}` },
            {
                id: "breadcrumb-recommended-sources",
                label: "Recommended Sources",
                type: "select",
                options: [{ id: "all_research", label: "All Research" }],
                to: `/article-list/${project_ref}/${draft_refcode}`,
            },
            { id: "breadcrumb-article-content", label: "Review Draft", to: `/article-content/${project_ref}/${draft_refcode}` },
        ]}
    />
    <div class="d-flex gap-2">
        <EmailBadge />
        <button class="btn btn-primary btn-logout" on:click={handleLogout}> Logout </button>
    </div>
</header>

<style>
    .header {
        z-index: 150;
        display: none;
        gap: 1rem;
        grid-column: 1 / 5;
        grid-row: 1;
        align-items: center;
        padding-left: 1rem;
        padding-right: 1rem;
        background-color: #f8ecde;
        transition: 0.35s ease all;
    }
    .header.show {
        display: flex;
    }
    .header .btn.btn-logout {
        grid-column: 4;
        text-align: center;
    }
</style>
